import { useLayoutEffect, useState } from 'react'

/**
 * Check if image format is supported
 * @param format
 * @param dataUri
 * @returns
 */
export const isFormatSupported = (format: string, dataUri: string) =>
  new Promise<true>((resolve, reject) => {
    const image = new Image()

    image.src = `data:image/${format};base64,${dataUri}`

    image.onload = () => {
      resolve(true)
    }

    image.onerror = () => {
      reject(format.toUpperCase() + ' format not supported')
    }
  })

export const isAvifSupported = () =>
  isFormatSupported(
    'avif',
    'AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A='
  )

export const isWebpAlphaSupported = () =>
  isFormatSupported(
    'webp',
    'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA=='
  )

export type ImageFormat = 'avif' | 'webp' | 'png' | 'jpeg' | 'jpg'

export function useImageFormat(fallback: ImageFormat = 'png') {
  const [betterFormat, setBetterFormat] = useState<ImageFormat>(fallback)

  useLayoutEffect(() => {
    const checkFormat = async () => {
      const avifSupported = await isAvifSupported()
      const webpAlphaSupported = await isWebpAlphaSupported()

      if (avifSupported) {
        setBetterFormat('avif')
      } else if (webpAlphaSupported) {
        setBetterFormat('webp')
      }
    }

    checkFormat()
  }, [])

  return betterFormat
}
